import script from "./JournalEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./JournalEditor.vue?vue&type=script&setup=true&lang=js"

import "./JournalEditor.vue?vue&type=style&index=0&id=4ef6451d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ef6451d"]])

export default __exports__